export default __webpack_public_path__ + "static/media/291.f76d2921.jpg";